import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import React, { useMemo } from 'react'
import useContentTag from 'hooks/Content/useContentTag'
import { getContentTagIcon } from './contentTagIconUtils'

interface Props {
  slug: string
  /**
   * Variant for PromotionLabel
   * @default 'engagement'
   */
  variant?: 'default' | 'premium' | 'engagement'
}

/**
 * Component that renders a ContentTag as a PromotionLabel
 */
function ContentTagLabel({
  slug,
  variant = 'engagement',
}: Props) {
  const { contentTag } = useContentTag(slug)

  const icon = useMemo(() => {
    if (!contentTag) {
      return undefined
    }
    return getContentTagIcon(contentTag.fields.icon)
  }, [contentTag])

  if (!contentTag) {
    return null
  }

  const { fields } = contentTag

  return (
    <PromotionLabel variant={variant} icon={icon}>
      {fields.title}
    </PromotionLabel>
  )
}
export default ContentTagLabel
